import { HOST_OVERRIDES } from './host-overrides';

export function resolveRpcHost(rpcPath: string, env: string): string {
  const fullService = rpcPath.split('/')[0];

  if (HOST_OVERRIDES[fullService]) {
    return HOST_OVERRIDES[fullService].replace('${ENV}', env);
  }

  const parts = fullService.split('.');
  const prefix = parts
    .slice(0, -1)
    .filter((p) => !/^v\d+/.test(p))
    .join('-')
    .replace(/_/g, '-');

  return `https://${prefix}-${env}.apigateway.co`;
}
